import ConnectedWorkoutApp from './connected-workout-app';
import mockApp from './debug/mock-app';
import GarminConnect from './GarminConnect/garminconnect';
import healthConnect from './HealthConnect/HealthConnect';
import healthKit from './HealthKit/healthkit';

export const allSupportedConnectsAppsInPriorityOrder: ConnectedWorkoutApp[] = [
  GarminConnect,
  healthKit,
  healthConnect,
  mockApp, // always last
];
